import {APP} from 'jsAssets/constants/app';
import _u from "jsAssets/utils/index";

// initial state
const state = {
    compareItems: null,
};

// getters
const getters = {
    compareItems: state => state.compareItems,
};

// actions
const actions = {
    addItemToCompare ({ commit }, productId) {
        let params = {
            'handler': 'compare_products',
            'func': 'addProductId',
            'productId': productId
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setCompareItems', responseData.data.data.listCompareProductsId);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    removeCompareItem ({ commit }, productId) {
        let params = {
            'handler': 'compare_products',
            'func': 'removeProductId',
            'productId': productId
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setCompareItems', responseData.data.data.listCompareProductsId);
            commit('app/setLoadingData', false, { root: true });
        });
    },

};

// mutations
const mutations = {
    setCompareItems (state, compareItems) {
        state.compareItems = compareItems;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
